module.exports = __webpack_public_path__ + "static/media/deposit-eth.5c17e8fa.svg";